"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";
import TrustImg from "../../assets/images/OfficeSpace.jpg";
import ContactButton from "../../components/shared/ContactButton";

export function Trust() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#5994CF] text-white">
      <div className="container mx-auto container md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="mb-12 grid grid-cols-1 items-start justify-between gap-x-12 gap-y-5 md:mb-18 md:grid-cols-2 md:gap-x-12 md:gap-y-8 lg:mb-20 lg:gap-x-20">
          <div>
            <p className="mb-3  md:mb-4 font-bold text-lg">Vertrauen</p>
            <h3 className="rb-5 mb-5 text-2xl md:mb-6 md:text-3xl lg:text-5xl lg:leading-15">
            Warum Kunden in unsere Sicherheits-Lösungen vertrauen?          </h3>
          </div>
          <div>
            <h3 className="mb-3  md:mb-4 font-bold text-lg" >Warum wir?</h3>
            <p className="md:text-md">
            Unser Team besteht aus zertifizierten Sicherheitsexperten mit langjähriger Erfahrung und unsere Kunden schätzen unsere Zuverlässigkeit und unser Engagement für ihre Sicherheit. Dabei gibt es kein Schema F, sondern für jede Herausforderung genau die Lösung, die für Sie die einfachste, kostengünstigste und vor allem sicherste ist. 
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8 ">
           <ContactButton/>
            </div>
          </div>
        </div>
        <img
          src={TrustImg}
          className="w-full object-cover h-[700px] rounded-4xl"
          alt="Relume placeholder image"
        />
      </div>
    </section>
  );
}
